/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostUsersIdRestorePathParams,
  PostUsersIdRestore200,
  PostUsersIdRestore400,
  PostUsersIdRestore403,
  PostUsersIdRestoreMutationResponse,
} from '../entities/PostUsersIdRestore'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const postUsersIdRestorePathParamsSchema = z.object({
  id: z.string().describe('ID пользователя'),
}) as unknown as ToZod<PostUsersIdRestorePathParams>

/**
 * @description OK
 */
export const postUsersIdRestore200Schema = z.any() as unknown as ToZod<PostUsersIdRestore200>

/**
 * @description Bad Request
 */
export const postUsersIdRestore400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostUsersIdRestore400>

/**
 * @description Forbidden
 */
export const postUsersIdRestore403Schema = z.any() as unknown as ToZod<PostUsersIdRestore403>

export const postUsersIdRestoreMutationResponseSchema = z.lazy(() => postUsersIdRestore200Schema) as unknown as ToZod<PostUsersIdRestoreMutationResponse>